export const INCREASE_DIALOG_COUNTER = 'INCREASE_DIALOG_COUNTER';
export const DISMISS_DIALOG = 'DISMISS_DIALOG';
